module.exports = __webpack_public_path__ + "img/Wesserman.49c3b223.jpg";